<template>
  <div id="FlyDetail" v-bind="$attrs" v-on="$listeners">
    <div class="header">
      <div class="airline-line">
        {{ getCityStr(flight.depart) }}
        <img src="~@img/airticket.png" alt="" />
        {{ getCityStr(flight.arrive) }}
      </div>
      <div class="duration">
        总时长{{
          getFlyTime(
            flight.departTime,
            flight.arriveTime
          )
        }}
      </div>
    </div>
    <template v-if="transferFlight.arrive">
      <div class="flight-item">
        <div>
          <div class="airline">
            <img :src="`${airLineImgUrl}${flight.airline}.png`" />
            {{ `${airMap[flight.airline]} ${flight.no}` }}
            <el-popover
              v-if="flight.shared == '1'"
              placement="top-start"
              width="200"
              trigger="hover"
            >
              <div>
                实际乘坐：{{ airMap[flight.operatingNo.substr(0, 2)]
                }}{{ flight.operatingNo }} <br />请按实际乘坐航班办理值机。
              </div>
              <span
                class="tt-icon tt-bg-green2 tt-ml10 tt-mr10"
                slot="reference"
              >
                共
              </span>
            </el-popover>
            <span
              v-if="salePrices.violates.length"
              class="tt-icon tt-bg-red tt-ml10 tt-mr10"
            >
              违
            </span>
            <span class="tt-icon tt-bg-blue tt-ml10 tt-mr10">
              {{ PRICETYPE[salePrices.priceType] }}
            </span>
            <span v-if="MEALS_TYPE[flight.meals]" class="meals tt-ml10 tt-mr10">
              {{ MEALS_TYPE[flight.meals] }}
            </span>
          </div>
          <div class="airline-detail">
            <div class="airport">
              <div class="dot"></div>
              {{ flight.departTime | formatDateMD }}
              {{ flight.departTime | formatDate4HHmm }}
              {{ flight.depart }}
              {{ airportMap[flight.depart] }}
              {{ flight.departTerminal }}
            </div>
            <div class="fly-time">
              <div class="dot"></div>
              飞行
              {{ getFlyTime(flight.departTime, transferFlight.arriveTime) }}
            </div>
            <div class="airport">
              <div class="dot"></div>
              {{ transferFlight.arriveTime | formatDateMD }}
              {{ transferFlight.arriveTime | formatDate4HHmm }}
              {{ transferFlight.arrive }}
              {{ airportMap[transferFlight.arrive] }}
              {{ transferFlight.arriveTerminal }}
            </div>
          </div>
        </div>
      </div>
      <div class="transfer-detail">
        <div class="main-info">
          <div style="display: flex; align-items: center">
            <div class="dot"></div>
            {{ getCityStr(transferFlight.arrive) }}
            <span class="tt-fw-bold tt-orange tt-ml5 tt-mr5 tt-fs-14">
              中转
            </span>
            停留{{ getFlyTime(transferFlight.arriveTime, transferFlight.departTime) }}
            <div class="tags" v-show="!active">
              <div class="tt-orange show-detail" @click="active = !active">
                预订说明
              </div>
            </div>
          </div>
          <div class="show-detail" @click="active = !active">
            {{ active ? "收起" : "展开" }}
            <i
              class="moretips"
              :class="active ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
            ></i>
          </div>
        </div>
        <div class="detail-content" v-show="active">
          <div class="detail-item">
            <div class="name">预订说明</div>
            <div class="detail-info">
              本产品为航司特惠产品，如遇航司系统原因，导致出票失败，天泰将会为您自动取消订单并全额退款。
            </div>
          </div>
        </div>
      </div>
      <div class="flight-item">
        <div>
          <div class="airline">
            <img :src="`${airLineImgUrl}${transferFlight.airline}.png`" />
            {{ `${airMap[transferFlight.airline]} ${transferFlight.no}` }}
            <el-popover
              v-if="transferFlight.shared == '1'"
              placement="top-start"
              width="200"
              trigger="hover"
            >
              <div>
                实际乘坐：{{ airMap[transferFlight.operatingNo.substr(0, 2)]
                }}{{ transferFlight.operatingNo }}
                <br />请按实际乘坐航班办理值机。
              </div>
              <span
                class="tt-icon tt-bg-green2 tt-ml10 tt-mr10"
                slot="reference"
              >
                共
              </span>
            </el-popover>
            <span
              v-if="
                salePrices.transferPrice &&
                salePrices.transferPrice.violates &&
                salePrices.transferPrice.violates.length
              "
              class="tt-icon tt-bg-red tt-ml10 tt-mr10"
            >
              违
            </span>
            <span
              class="tt-icon tt-bg-blue tt-ml10 tt-mr10"
              v-if="salePrices.transferPrice"
            >
              {{ PRICETYPE[salePrices.transferPrice.priceType] }}
            </span>
            <span
              v-if="MEALS_TYPE[transferFlight.meals]"
              class="meals tt-ml10 tt-mr10"
            >
              {{ MEALS_TYPE[transferFlight.meals] }}
            </span>
          </div>
          <div class="airline-detail">
            <div class="airport">
              <div class="dot"></div>
              {{ transferFlight.departTime | formatDateMD }}
              {{ transferFlight.departTime | formatDate4HHmm }}
              {{ transferFlight.depart }}
              {{ airportMap[transferFlight.depart] }}
              {{ transferFlight.departTerminal }}
            </div>
            <div class="fly-time">
              <div class="dot"></div>
              飞行
              {{
                getFlyTime(transferFlight.departTime, flight.arriveTime)
              }}
            </div>
            <div class="airport">
              <div class="dot"></div>
              {{ flight.arriveTime | formatDateMD }}
              {{ flight.arriveTime | formatDate4HHmm }}
              {{ flight.arrive }}
              {{ airportMap[flight.arrive] }}
              {{ flight.arriveTerminal }}
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="stopInfoObj[flight.depart + flight.arrive]">
      <div class="flight-item">
        <div>
          <div class="airline">
            <img :src="`${airLineImgUrl}${flight.airline}.png`" />
            {{ `${airMap[flight.airline]} ${flight.no}` }}
          </div>
          <div class="airline-detail">
            <div class="airport">
              <div class="dot"></div>
              {{ flight.departTime | formatDateMD }}
              {{ flight.departTime | formatDate4HHmm }}
              {{ flight.depart }}
              {{ airportMap[flight.depart] }}
              {{ flight.departTerminal }}
            </div>
            <div class="fly-time">
              <div class="dot"></div>
              飞行
              {{
                getFlyTime(
                  flight.departTime,
                  stopInfoObj[flight.depart + flight.arrive].arriveTime
                )
              }}
            </div>
            <div class="airport">
              <div class="dot"></div>
              {{
                stopInfoObj[flight.depart + flight.arrive].arriveTime
                  | formatDateMD
              }}
              {{
                stopInfoObj[flight.depart + flight.arrive].arriveTime
                  | formatDate4HHmm
              }}
              {{ stopInfoObj[flight.depart + flight.arrive].arrive }}
              {{
                airportMap[stopInfoObj[flight.depart + flight.arrive].arrive]
              }}
              {{ stopInfoObj[flight.depart + flight.arrive].arriveTerminal }}
            </div>
          </div>
        </div>
      </div>
      <div class="transfer-detail">
        <div class="main-info">
          <div style="display: flex; align-items: center">
            <div class="dot"></div>
            {{ getCityStr(stopInfoObj[flight.depart + flight.arrive].arrive) }}
            <span class="tt-fw-bold tt-orange tt-ml5 tt-mr5 tt-fs-14">
              经停
            </span>
            停留{{
              getFlyTime(
                stopInfoObj[flight.depart + flight.arrive].arriveTime,
                stopInfoObj[flight.depart + flight.arrive].departTime
              )
            }}
          </div>
        </div>
      </div>
      <div class="flight-item">
        <div>
          <div class="airline-detail">
            <div class="airport">
              <div class="dot"></div>
              {{
                stopInfoObj[flight.depart + flight.arrive].departTime
                  | formatDateMD
              }}
              {{
                stopInfoObj[flight.depart + flight.arrive].departTime
                  | formatDate4HHmm
              }}
              {{ stopInfoObj[flight.depart + flight.arrive].depart }}
              {{
                airportMap[stopInfoObj[flight.depart + flight.arrive].depart]
              }}
              {{ stopInfoObj[flight.depart + flight.arrive].departTerminal }}
            </div>
            <div class="fly-time">
              <div class="dot"></div>
              飞行
              {{
                getFlyTime(
                  flight.departTime,
                  stopInfoObj[flight.depart + flight.arrive].arriveTime
                )
              }}
            </div>
            <div class="airport">
              <div class="dot"></div>
              {{ flight.arriveTime | formatDateMD }}
              {{ flight.arriveTime | formatDate4HHmm }}
              {{ flight.arrive }}
              {{ airportMap[flight.arrive] }}
              {{ flight.arriveTerminal }}
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import { mapState } from 'vuex'
export default {
  name: 'FlyDetail',
  data () {
    return {
      cityList: [],
      airportMap: {},
      airMap: {},
      transferFlight: {},
      active: false,
      stopInfoObj: {},
      salePrices: {},
      flight: {}
    }
  },
  computed: {
    ...mapState(['indexStore']),
    obj () {
      return this.$attrs.obj || {}
    }
  },
  watch: {
    obj: {
      handler (n) {
        if (n) {
          this.loadData()
        }
      },
      immediate: true,
      deep: true
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    // 加载基础数据
    async loadData () {
      const { airport, aircodedata, dict } = this.indexStore
      this.PRICETYPE = dict.PRICETYPE
      this.MEALS_TYPE = dict.MEALS_TYPE
      this.cityList = airport.airportList
      this.airportMap = airport.airportMap
      this.airMap = aircodedata.airMap
      this.flight = this.obj.flight || {}
      this.salePrices = this.obj.salePrices || {}
      if (
        this.flight.cabins &&
        this.flight.cabins[0] &&
        this.flight.cabins[0].salePrices[0]
      ) {
        this.salePrices = this.flight.cabins[0].salePrices[0] || {}
      }
      this.transferFlight = this.flight.transferFlight || {}
      this.renderStop()
    },
    // 获取城市
    getCityStr (s) {
      let c = this.cityList.filter((cl) => cl.airportCode === s)[0] || {}
      return c.cityCName
    },
    // 获取时长
    getFlyTime (s, a) {
      let diff = dayjs(a).diff(s)
      let h = Math.floor(diff / (1000 * 60 * 60))
      let sen = (diff / (1000 * 60)) % 60
      let str = ''
      h && (str += `${h}小时`)
      sen && (str += `${sen}分`)
      return str
    },
    // 组成经停数据
    renderStop () {
      let { stopInfos } = this.flight
      this.stopInfoObj = {}
      for (let index = 0; index < (stopInfos || []).length; index++) {
        // 第一段
        const element = stopInfos[index]
        const nextIndex = index + 1
        if (nextIndex < stopInfos.length) {
          // 第二段
          const nexrElement = stopInfos[nextIndex]
          let key = `${element.departureAirport}${nexrElement.arrivalAirport}`
          this.stopInfoObj[key] = {
            arrive: element.arrivalAirport,
            depart: nexrElement.departureAirport,
            arriveTime: element.arrivalDateTime,
            departTime: nexrElement.departureDateTime
          }
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
#FlyDetail {
  padding: 20px 0;
  .header {
    display: flex;
    font-size: 20px;
    .airline-line {
      color: #333;
      font-weight: 600;
      margin-right: 16px;
      display: flex;
      align-items: center;
      img {
        margin: 0 10px;
        width: 20px;
        height: 20px;
      }
    }
    .duration {
      color: #999;
    }
  }
  .flight-item {
    padding-top: 20px;
    &:not(:last-of-type) {
      padding-bottom: 16px;
      border-bottom: 1px solid #eef1f6;
    }
    .airline {
      height: 22px;
      margin-bottom: 17px;
      display: flex;
      align-items: center;
      img {
        width: 17px;
        vertical-align: middle;
        margin-right: 10px;
      }
    }
    .airline-detail {
      .dot {
        width: 6px;
        background: #99aeca;
        margin-right: 20px;
      }
      .airport {
        display: flex;
        align-items: center;
        .dot {
          height: 6px;
        }
      }
      .fly-time {
        display: flex;
        height: 86px;
        align-items: center;
        color: #999;
        font-size: 12px;
        .dot {
          height: 100%;
        }
      }
    }
  }
  .transfer-detail {
    padding: 8px 0;
    border-bottom: 1px solid #eef1f6;
    font-size: 12px;
    .main-info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-right: 10px;
      .dot {
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background: #f60;
        margin-right: 8px;
      }
      .tags {
        margin-left: 13px;
      }
      .show-detail {
        cursor: pointer;
      }
    }
    .detail-content {
      padding: 13px;
      .detail-item {
        margin-top: 8px;
        line-height: 14px;
        display: flex;
        .name {
          color: #f60;
          white-space: nowrap;
        }
        .detail-info {
          color: #999;
          margin-left: 8px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FlyDetail.vue